module.exports = __webpack_public_path__ + "static/London-Lauriston-7a730ef0ceab017cd107fe2d7733b683.jpg";